import { useSelector } from 'react-redux';
import { getAuthorizationToken } from '../store';

export function useGetAuthorizationToken() {
  const token = useSelector(getAuthorizationToken);
  return { token };
}
